function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
var _require = require('./explorer-format'),
  formatSaito = _require.formatSaito,
  truncatePublicKey = _require.truncatePublicKey;
function parseBalanceSnapshotNolan(text) {
  if (!text || typeof text !== 'string') {
    return 0n;
  }
  var total = 0n;
  var lines = text.trim().split('\n');
  for (var i = 0; i < lines.length; i++) {
    var cols = lines[i].split(' ');
    if (cols.length < 5) {
      continue;
    }
    try {
      total += BigInt(cols[4]);
    } catch (err) {
      // skip malformed rows
    }
  }
  return total;
}
function fetchPeerCount() {
  return _fetchPeerCount.apply(this, arguments);
}
function _fetchPeerCount() {
  _fetchPeerCount = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var response, data, peers;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return fetch('/json/peers');
        case 1:
          response = _context.v;
          if (response.ok) {
            _context.n = 2;
            break;
          }
          throw new Error('peer stats unavailable');
        case 2:
          _context.n = 3;
          return response.json();
        case 3:
          data = _context.v;
          peers = Array.isArray(data === null || data === void 0 ? void 0 : data.peers) ? data.peers : [];
          return _context.a(2, peers.length);
      }
    }, _callee);
  }));
  return _fetchPeerCount.apply(this, arguments);
}
function fetchBalanceNolan(_x) {
  return _fetchBalanceNolan.apply(this, arguments);
}
function _fetchBalanceNolan() {
  _fetchBalanceNolan = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(publicKey) {
    var response, text;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          if (publicKey) {
            _context2.n = 1;
            break;
          }
          return _context2.a(2, null);
        case 1:
          _context2.n = 2;
          return fetch("/balance/".concat(encodeURIComponent(publicKey)));
        case 2:
          response = _context2.v;
          if (response.ok) {
            _context2.n = 3;
            break;
          }
          throw new Error('balance unavailable');
        case 3:
          _context2.n = 4;
          return response.text();
        case 4:
          text = _context2.v;
          return _context2.a(2, parseBalanceSnapshotNolan(text));
      }
    }, _callee2);
  }));
  return _fetchBalanceNolan.apply(this, arguments);
}
function resolveEndpoint() {
  if (typeof window === 'undefined' || !window.location) {
    return '—';
  }
  return window.location.origin || window.location.host || '—';
}
function buildPeerNodeInfo(_x2, _x3) {
  return _buildPeerNodeInfo.apply(this, arguments);
}
function _buildPeerNodeInfo() {
  _buildPeerNodeInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(app, mod) {
    var _window;
    var peer, publicKey, endpoint, _yield$Promise$all, _yield$Promise$all2, peerCount, balanceNolan;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          peer = mod === null || mod === void 0 ? void 0 : mod.explorerPeer;
          publicKey = String((peer === null || peer === void 0 ? void 0 : peer.publicKey) || '').trim();
          if (publicKey) {
            _context3.n = 1;
            break;
          }
          return _context3.a(2, {
            ready: false,
            loading: true,
            error: null
          });
        case 1:
          endpoint = resolveEndpoint();
          _context3.n = 2;
          return Promise.all([fetchPeerCount()["catch"](function () {
            return null;
          }), fetchBalanceNolan(publicKey)["catch"](function () {
            return null;
          })]);
        case 2:
          _yield$Promise$all = _context3.v;
          _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
          peerCount = _yield$Promise$all2[0];
          balanceNolan = _yield$Promise$all2[1];
          return _context3.a(2, {
            ready: true,
            loading: false,
            error: null,
            publicKey: publicKey,
            publicKeyDisplay: truncatePublicKey(publicKey, 16),
            balance: balanceNolan != null ? formatSaito(balanceNolan) : '—',
            peerCount: peerCount != null ? String(peerCount) : '—',
            endpoint: endpoint,
            endpointDisplay: ((_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.host) || endpoint
          });
      }
    }, _callee3);
  }));
  return _buildPeerNodeInfo.apply(this, arguments);
}
module.exports = {
  buildPeerNodeInfo: buildPeerNodeInfo,
  parseBalanceSnapshotNolan: parseBalanceSnapshotNolan
};